import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "detail-content"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "source" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_TaggedMarkdown = _resolveComponent("TaggedMarkdown")!
  const _component_TextBlock = _resolveComponent("TextBlock")!
  const _component_Markdown = _resolveComponent("Markdown")!
  const _component_ContentDetail = _resolveComponent("ContentDetail")!

  return (_openBlock(), _createBlock(_component_ContentDetail, {
    content: _ctx.tag,
    related: _ctx.fullTag?.related,
    "init-open": _ctx.initOpen,
    onOpen: _ctx.onOpenContent
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Loader, {
        loading: _ctx.loading,
        absolute: ""
      }, null, 8, ["loading"]),
      _createVNode(_Transition, {
        name: "fade-delay",
        onAfterEnter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open-detail')))
      }, {
        default: _withCtx(() => [
          (_ctx.fullTag?.tag)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("header", null, [
                  (_ctx.first)
                    ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_ctx.tag.title), 1))
                    : (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_ctx.tag.title), 1))
                ]),
                _createVNode(_component_TaggedMarkdown, {
                  class: "intro",
                  text: _ctx.tag.introText,
                  tags: _ctx.tag.tags
                }, null, 8, ["text", "tags"]),
                (_ctx.fullTag.tag.textWithImage)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.fullTag.tag.textWithImage, (textBlock, index) => {
                      return (_openBlock(), _createBlock(_component_TextBlock, {
                        key: index,
                        content: textBlock,
                        tags: _ctx.tag.tags
                      }, null, 8, ["content", "tags"]))
                    }), 128))
                  : _createCommentVNode("", true),
                _createElementVNode("aside", _hoisted_4, [
                  (_ctx.fullTag.tag.source)
                    ? (_openBlock(), _createBlock(_component_Markdown, {
                        key: 0,
                        text: `Bron: ${_ctx.fullTag.tag.source}`
                      }, null, 8, ["text"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["content", "related", "init-open", "onOpen"]))
}